/*------------------------------------------------------------------------------

  東ソーの挑戦

------------------------------------------------------------------------------*/
$(function() {
  let mySwiper = new Swiper('.about_driven_swiper-container', {
    effect: 'coverflow',
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: false,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.about_driven_swiper-container .swiper-button-next',
      prevEl: '.about_driven_swiper-container .swiper-button-prev',
    },
  });
});
